export interface HijoResumen {
  studentId: string;
  relacion: string | null;
  matricula: string;
  nombre: string;
  gradoName: string;
  groupName: string;
  institutionName: string;
  teacherName: string;
}

export interface HijosState {
  hijos: HijoResumen[];
  loading: boolean;
  error: string | null;
}

export const initialHijosState: HijosState = {
  hijos: [],
  loading: false,
  error: null,
};
